import React, { Component, Suspense } from "react";
import { Spinner } from "reactstrap";

class TemplateManagementLazy extends Component {
  render() {
    const TemplateManagement = React.lazy(() =>
      import(/* webpackChunkName: "TemplateManagement" */ "./TemplateManagement")
    );
    return (
      <Suspense fallback={<Spinner color="primary" />}>
        <TemplateManagement {...this.props} />
      </Suspense>
    );
  }
}

export default TemplateManagementLazy;
